"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartVariant = void 0;
// eslint-disable-next-line no-shadow
var ChartVariant;
(function (ChartVariant) {
    ChartVariant["COUNT_GROUP"] = "count_group";
    ChartVariant["COUNT_TIME"] = "count_time";
    ChartVariant["COUNT_GROUP_TIME"] = "count_group_time";
    ChartVariant["PERF_GROUP_TIME"] = "perf_group_time";
    ChartVariant["SCORE_Q_OP"] = "score_q_op";
})(ChartVariant = exports.ChartVariant || (exports.ChartVariant = {}));
exports.default = ChartVariant;
